/**
 * Created by Alex Xia on 4/26/2023.
 * Description:
 * add sidenote button on calendar screen
 * ------ maintenance history ------
 */

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NoteService } from '../../services/note.service';
import { ThreadDetailService } from '../../services/thread-detail.service';
import { NoteDialogOpenOptions, NoteDialogType } from '../note-dialog/note-dialog.model';
import { NoteDialogService } from '../note-dialog/note-dialog.service';
@Component({
    selector: 'tam-calendar-add-sidenote',
    template: `<div kendoTooltip><smart-icon #anchor name='add-sidenote' class='add-side-note-icon hover-color' (click)='clicked($event)' title="Add sidenote"></smart-icon></div>`,
    styleUrls: ['./calendar-screen.component.scss']
})
export class CalendarScreenAddSideNoteComponent implements ICellRendererAngularComp {
    private _params: any;
    constructor(
        private _noteDialogService: NoteDialogService,
        private _noteService: NoteService,
    ) { }

    agInit(params: any): void {
        this._params = params;
    }

    public clicked(e): void {
        const _noteOption = new NoteDialogOpenOptions();
        const sidenoteInfo = this._noteService.getSidenoteInfoBySettingRule(this._params.notes, this._params.notesInThread);
        if (sidenoteInfo) {
            _noteOption.entryId = sidenoteInfo.entryId;
            _noteOption.entryTypeId = sidenoteInfo.entryTypeId;
        } else {
            _noteOption.entryId = this._params.threadId;
        }

        _noteOption.openType = NoteDialogType.AddSideNote;
        _noteOption.minimizable = true;
        _noteOption.entityFieldEditable = this._params.isEntityFieldEditableInSideNote;
        this._noteDialogService.dialogOpen$.next(_noteOption);
    }

    refresh(): boolean {
        return false;
    }
}
